import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

interface UpgradePromptProps {
  feature?: string; 
}

export function UpgradePrompt({ feature }: UpgradePromptProps) {
  return (
    <div className="min-h-screen bg-background-dark flex items-center justify-center p-4 text-black">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-[#2a1114] mb-6">
            <Lock className="h-8 w-8 text-white" />
          </div>
          
          <h2 className="text-2xl font-bold text-black mb-4">
            Premium Feature
          </h2>
          
          <p className="text-black mb-8">
            {feature ? `Access to ${feature} is` : 'This feature is'} only available to Tezhly members. Join to unlock full access to jobs and resume reviews.
          </p>
          
          <Link 
            to="/subscription"
            className="inline-block px-8 py-4 bg-[#2a1114] text-white font-medium rounded-xl hover:opacity-90 transition-all w-full"
          >
            Join Tezhly:Career Labs
          </Link>
        </div>
      </div>
    </div>
  );
}